import Styled from 'styled-components';

const Greeting = Styled.div`
  order: 0;
`;

Greeting.displayName = 'LandingGreeting';

export default Greeting;
